import styled from 'styled-components';
import { IntroContainer } from 'pages/intro/Intro.styled';
import { prem } from 'styles/helpers/spacing';
import { IonInputWrapper } from 'components/common/form/textfield/Textfield.styled';
import { IonButtonWrapper } from 'components/common/button/Button.styled';
import { FONT_SIZES } from 'styles/constants/fonts';
import { FormErrorWrapper } from 'components/common/form/Form.styled';

const ForgottenpwdTitle = styled.h2`
  margin-bottom: ${prem(20)};
  font-size: ${prem(FONT_SIZES.SUBTITLE.MOBILE_S)};
`;

const ForgottenpwdWrapper = styled(IntroContainer)`
  height: unset;
  width: 73%;
  max-width: ${prem(500)};
  min-width: ${prem(250)};
  text-align: center;
  margin: ${prem(25)} auto 0;

  ${IonInputWrapper} {
    margin-bottom: ${prem(25)};
  }

  ${IonButtonWrapper} {
    margin: ${prem(77)} auto ${prem(24)};
    width: 50%;
    min-width: ${prem(190)};
    max-width: ${prem(250)};
  }

  .pwd-changed {
    p {
      font-size: ${prem(18)};
      margin-bottom: ${prem(24)};
    }
  }

  &.step-2 {
    ${ForgottenpwdTitle} {
      margin-bottom: ${prem(30)};
    }
  }
`;

const ForgottenpwdInstruction = styled.div`
  margin-bottom: ${prem(34)};

  &.newpwd {
    margin-bottom: ${prem(16)};
  }

  p {
    margin-bottom: ${prem(17)};
  }

  ul {
    text-align: left;
  }
`;

const ForgottenPwdNew = styled.div`
  ${IonButtonWrapper} {
    margin: ${prem(50)} auto ${prem(24)};
  }

  ${FormErrorWrapper} {
    margin: ${prem(20)} 0;
  }
`;

const ForgottenpwdOptionsWrapper = styled.div`
  .options-buttons {
    display: flex;
    flex-direction: column;
    gap: ${prem(20)};
    margin-bottom: ${prem(30)};
  }

  .option-button {
    --padding-start: ${prem(20)};
    --padding-end: ${prem(20)};
    --padding-top: ${prem(20)};
    --padding-bottom: ${prem(20)};
    height: auto;
    min-height: ${prem(80)};

    .option-content {
      display: flex;
      flex-direction: column;
      text-align: left;
      width: 100%;
      text-wrap: wrap;
      line-height: 1.4;
    }

    .option-title {
      font-weight: bold;
      font-size: ${prem(16)};
      margin-bottom: ${prem(5)};
    }

    .option-description {
      font-size: ${prem(14)};
      opacity: 0.8;
    }
  }

  .back-button {
    margin-top: ${prem(20)};
  }
`;

const ForgottenpwdContactTrainerWrapper = styled.div`
  .trainer-info {
    background-color: #f0f0f0;
    padding: ${prem(20)};
    border-radius: ${prem(8)};
    margin: ${prem(20)} 0;

    p {
      margin: 0;
      font-size: ${prem(14)};
    }
  }

  .success-message {
    text-align: center;
    
    .trainer-info {
      background-color: #e8f5e8;
      border: 1px solid #28a745;
      color: #155724;
    }
  }

  .contact-trainer-button {
    margin: ${prem(30)} auto ${prem(20)};
    width: 80%;
    text-wrap: wrap;
    line-height: 2;
  }

  .back-button {
    margin-top: ${prem(20)};
  }
`;

export { 
  ForgottenpwdWrapper, 
  ForgottenpwdTitle, 
  ForgottenpwdInstruction, 
  ForgottenPwdNew,
  ForgottenpwdOptionsWrapper,
  ForgottenpwdContactTrainerWrapper
};
